/**
 * The viewport width, kept current across resizes.
 *
 * Feature 257 — the board reads this to decide how many columns it can carry,
 * which is how it adapts to the screen it is on without a venue setting.
 */
import { useEffect, useState } from "react";

export function useViewportWidth(fallback = 1366): number {
  const [width, setWidth] = useState(
    typeof window === "undefined" ? fallback : window.innerWidth,
  );

  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return width;
}
